import { render } from "./SensorCard.vue?vue&type=template&id=6df0b4f0&scoped=true"
import script from "./SensorCard.vue?vue&type=script&lang=js"
export * from "./SensorCard.vue?vue&type=script&lang=js"

import "./SensorCard.vue?vue&type=style&index=0&id=6df0b4f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df0b4f0"]])

export default __exports__